import { render, staticRenderFns } from "./AggregatorTransaction.vue?vue&type=template&id=cde2f7a8"
import script from "./AggregatorTransaction.vue?vue&type=script&lang=js"
export * from "./AggregatorTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports